import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "../../Typography";
const StatsLabel = ({ children, className }) => {
    if (typeof children !== "string")
        return children;
    return (_jsx(Typography, { variant: "body", className: className, children: children }));
};
StatsLabel.displayName = "Stats.Label";
export default StatsLabel;
